var map = {
	"./arrow_down.svg": "c32b",
	"./backspace.svg": "0aa9",
	"./buy_btn_0.svg": "74a6",
	"./buy_btn_1.svg": "0d52",
	"./buy_btn_4.svg": "3e66",
	"./buy_btn_5.svg": "aa0d",
	"./buy_corner_hot.svg": "be8c",
	"./buy_corner_new.svg": "c1b9",
	"./buy_corner_re.svg": "cb96",
	"./buy_corner_xin.svg": "167a",
	"./check_fill.svg": "a616",
	"./closing.svg": "321a",
	"./com_groupon.svg": "a907",
	"./com_seckill.svg": "8268",
	"./loading.svg": "d412",
	"./notice.svg": "fc99",
	"./pay_bank.svg": "5e98",
	"./pay_cash.svg": "61ef",
	"./pay_mobile.svg": "c1eb",
	"./trash.svg": "ce30"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "51ff";